import { useContext, useEffect, useState } from "react";
import { Table as TableAntd } from "antd";
import Text from "antd/es/typography/Text";
import { ThemeContext } from "../../contexts/ThemeContext";
import { TableProps } from "antd/es/table";

interface IProps extends TableProps<any> {
    tableData: Array<any>,
}

export default function Table({
    columns,
    tableData,
    rowSelection,
    loading,
    onRow,
    expandable,
    style,
    pagination,
}: IProps) {
    const { theme } = useContext(ThemeContext);

    const [filteredData, setFilteredData] = useState(tableData);
    const [activeFilters, setActiveFilters] = useState<any>({});

    useEffect(() => {
        setFilteredData(tableData);
        setActiveFilters({});
    }, [tableData]);

    const handleChange = (pagination: any, filters: any, sorter: any) => {
        setActiveFilters(filters);
        let data = [...tableData];

        for (const key in filters) {
            const filterValues = filters[key];
            if (filterValues && filterValues.length > 0) {
                data = data.filter(row => {
                    const rowValue = row[key];
                    if (Array.isArray(rowValue)) {
                        return rowValue.some(v => filterValues.includes(v.id));
                    }
                    if (rowValue && rowValue.id !== undefined) {
                        return filterValues.includes(rowValue.id);
                    }
                    return filterValues.includes(rowValue);
                });
            }
        }

        setFilteredData(data);
    };

    const enhancedColumns = columns?.map((col: any) => {
        if (col.filters) {
            return {
                ...col,
                filteredValue: activeFilters[col.key] || null
            };
        }
        return col;
    });

    return (
        <TableAntd
            columns={enhancedColumns}
            dataSource={filteredData}
            rowSelection={rowSelection}
            loading={loading}
            onRow={onRow}
            onChange={handleChange}
            scroll={{ x: 'max-content' }}
            style={{ marginTop: 50, ...style }}
            pagination={pagination || {
                showSizeChanger: true,
                position: ['topRight', 'bottomRight'],
                defaultPageSize: 10,
                pageSizeOptions: [10, 20, 50, 100]
            }}
            title={(data) => (
                <div style={{ backgroundColor: theme === 'light' ? '#FAFAFA' : '#1D1D1D', padding: 10, margin: -16, marginBottom: 0.5 }}>
                    <Text>Exibindo {data.length} de um total de {tableData.length} {tableData.length === 1 ? 'registro' : 'registros'}.</Text>
                </div>
            )}
            footer={(data) => (
                <div style={{ textAlign: 'end' }}>
                    <Text>Exibindo {data.length} de um total de {tableData.length} {tableData.length === 1 ? 'registro' : 'registros'}.</Text>
                </div>
            )}
            expandable={expandable}
        />
    );
}